import { useMemo } from 'react'
import { useLocalStorage } from '@/hooks/useLocalStorage'

import {
  numericSearchIds,
  type ProductSearchByOptions,
} from './useSearchOptionsByValue'

type ProductSearch = {
  id?: ProductSearchByOptions
  value: string
}

export function useProductSearch(prefix = '') {
  const [value, setValue] = useLocalStorage(
    `${prefix}adminCatalogProductSearchValue`,
    ''
  )
  const [searchBy, setSearchBy] = useLocalStorage<ProductSearchByOptions | ''>(
    `${prefix}adminCatalogProductSearchBy`,
    ''
  )
  const [pinnedSearchBy, setPinnedSearchBy] = useLocalStorage<
    ProductSearchByOptions | ''
  >(`${prefix}searchPinnedSearchBy`, '')

  const memoizedValue = useMemo(
    () => ({
      selectedItem: {
        id: searchBy || undefined,
        value,
      },
      setSelectedItem: (item: ProductSearch) => {
        let { value: newValue } = item
        const newSearchBy = item.id || ''

        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        if (numericSearchIds.includes(newSearchBy as any)) {
          newValue = newValue.replace(/\D/g, '')
        }

        setValue(newValue)
        setSearchBy(newSearchBy)
      },
      pinnedSearchBy,
      togglePinnedSearchBy: (searchByToPin: typeof searchBy = '') => {
        if (searchByToPin === pinnedSearchBy) {
          setPinnedSearchBy('')

          return
        }

        setPinnedSearchBy(searchByToPin)
      },
    }),
    [pinnedSearchBy, searchBy, setPinnedSearchBy, setSearchBy, setValue, value]
  )

  return memoizedValue
}
